import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AutenticacaoService } from 'src/app/frameworks/seguranca/servicos/autenticacao.service';
import { UsuarioConectado } from 'src/app/frameworks/seguranca/tipos/tipos.seguranca';
import { SegurancaService } from 'src/app/frameworks/seguranca/servicos/seguranca.service';
import { NavegacaoUtilService } from 'src/app/frameworks/utilitarios/servicos/navegacao-util.service';
import { ThemeService } from 'src/app/frameworks/utilitarios/servicos/theme.service';
import { CabecalhoContextoService } from 'src/app/frameworks/utilitarios/servicos/cabecalho-contexto.service';
import { PRINCIPAL } from 'src/app/global/navegacao';
import { RespostaServidorVO, AcessoQRY } from 'src/app/global/tiposPrevimil';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'prv-layout-lateral',
  templateUrl: './layout-lateral.component.html',
  styleUrls: ['./layout-lateral.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class LayoutLateralComponent implements OnInit {

  @Input() exibeBotaoVoltar: boolean = true;
  @Input() exibeBotaoHome: boolean;

  isCollapsed: boolean = true;
  usuarioConectadoInfo$: Observable<UsuarioConectado>;
  rotasNavegacao: any[] = [];

  constructor(
    private autenticacao: AutenticacaoService,
    private segurancaService: SegurancaService,
    private navegacaoService: NavegacaoUtilService,
    private router: Router,
    public temaService: ThemeService,
    public cabecalhoContexto: CabecalhoContextoService,
  ) { }

  ngOnInit(): void {
    this.usuarioConectadoInfo$ = this.autenticacao.usuarioConectadoOBS.asObservable();
    this.autenticacao.publicarDadosUsuario();
    this.carregarMenuNavegacao();
  }

  toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  public getAmbiente(): string {
    return environment.AMBIENTE;
  }

  public getAmbienteType(): 'dev' | 'homolog' | 'prod' {
    const a = environment.AMBIENTE || '';
    if (a === 'PRODUCAO' || a.includes('PRD') || a.includes('PROD')) return 'prod';
    if (a === 'HOMOLOG' || a.includes('HML')) return 'homolog';
    return 'dev';
  }

  getAmbienteAbrev(): string {
    const tipo = this.getAmbienteType();
    if (tipo === 'prod') return 'PRD';
    if (tipo === 'homolog') return 'HML';
    return 'DSV';
  }

  abreviarNome(nome: string): string {
    const partes = nome.split(' ');
    if (partes.length >= 2) {
      return (partes[0].substring(0, 4) + ' ' + partes[1].substring(0, 4)).trim();
    }
    return nome.substring(0, 8);
  }

  isActive(caminho: string): boolean {
    if (!this.router.url || !caminho) return false;
    const path = caminho.startsWith('/') ? caminho : '/' + caminho;
    return this.router.url.startsWith(path);
  }

  // Retorna o nome do módulo atual para exibir no botão VOLTAR (#14)
  getNomeModuloAtual(): string {
    const segmentos = this.router.url.split('/').filter(Boolean);
    if (segmentos.length < 2) return '';
    const primeiro = segmentos[0];
    const modulo = this.rotasNavegacao.find(r => {
      const rPath = (r.caminho.startsWith('/') ? r.caminho.slice(1) : r.caminho).split('/')[0];
      return rPath === primeiro;
    });
    if (!modulo) return '';
    return modulo.nome.length > 14 ? modulo.nome.substring(0, 12) + '…' : modulo.nome;
  }

  sairSistema(): void {
    this.autenticacao.sairSistema();
  }

  // --- LÓGICA DO BOTÃO VOLTAR ---

  public executarVoltar() {
    this.navegacaoService.voltar(null, this.exibeBotaoHome);
  }
  
private carregarMenuNavegacao(): void {
  const subItem = PRINCIPAL;

this.segurancaService.obterAcessosUsuario(subItem.idModulo).subscribe(
  resposta => {
    this.rotasNavegacao = (resposta as RespostaServidorVO<AcessoQRY[]>).sucesso || [];

    // 🔍 Remove o item "Segurança" pelo nome ou caminho
    this.rotasNavegacao = this.rotasNavegacao.filter(item => item.nome !== 'Segurança' && item.caminho !== '/seguranca');

      // Evita duplicidade caso o backend já traga algo relacionado à intranet
      const jaTemIntranet = this.rotasNavegacao.some(r => r.caminho === '/intranet');
      if (!jaTemIntranet) {
        this.rotasNavegacao.unshift({
          idMenu: 9999,
          nome: 'Intranet',
          caminho: '/intranet',
          icone: 'icone_menu icone_intranet'
        });
      }

      console.log('Menu Lateral carregado:', this.rotasNavegacao);
    },
    falha => {
      console.error('Falha ao carregar o menu de navegação:', falha);
      this.rotasNavegacao = [{
        idMenu: 9999,
        nome: 'Intranet',
        caminho: '/intranet',
        icone: 'icone_menu icone_intranet'
      }];
    }
  );
}
}